import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
  i18nRedirect,
  languagePrefixGuard,
  translateRouteResolver
} from '@gruposaltaedu/liv-i18n/router';
import { providePageTranslation } from '@gruposaltaedu/liv-i18n/translate';

import { interceptorGuard } from './core/security/guards/interceptor.guard';
import {
  errorIndexRedirectGuard,
  errorPageAccessGuard
} from './errors/guards/error-page-access.guard';

const errorPageProviders = [providePageTranslation('errors')];

const routes: Routes = [
  {
    path: ':lang',
    canMatch: [languagePrefixGuard],
    children: [
      {
        path: 'livro-do-professor',
        canActivate: [interceptorGuard],
        providers: [providePageTranslation('teacher-book')],
        resolve: {
          translationsReady: translateRouteResolver
        },
        loadChildren: () =>
          import('./shell/shell.module').then((m) => m.ShellModule)
      },
      {
        path: 'error',
        providers: errorPageProviders,
        resolve: {
          translationsReady: translateRouteResolver
        },
        children: [
          {
            path: 'session',
            canActivate: [errorPageAccessGuard],
            loadComponent: () =>
              import('./errors/pages/session-error/session-error.component').then(
                (m) => m.SessionErrorComponent
              )
          },
          {
            path: 'forbidden',
            canActivate: [errorPageAccessGuard],
            loadComponent: () =>
              import('./errors/pages/forbidden-error/forbidden-error.component').then(
                (m) => m.ForbiddenErrorComponent
              )
          },
          {
            path: 'unexpected',
            canActivate: [errorPageAccessGuard],
            loadComponent: () =>
              import('./errors/pages/unexpected-error/unexpected-error.component').then(
                (m) => m.UnexpectedErrorComponent
              )
          },
          {
            path: '',
            pathMatch: 'full',
            canActivate: [errorIndexRedirectGuard],
            loadComponent: () =>
              import('./errors/pages/not-found/not-found.component').then(
                (m) => m.NotFoundComponent
              )
          }
        ]
      },
      {
        path: '404',
        providers: errorPageProviders,
        resolve: {
          translationsReady: translateRouteResolver
        },
        loadComponent: () =>
          import('./errors/pages/not-found/not-found.component').then(
            (m) => m.NotFoundComponent
          )
      },
      {
        path: '**',
        redirectTo: '404'
      }
    ]
  },
  {
    path: '**',
    redirectTo: i18nRedirect
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
